module.exports = __webpack_public_path__ + "static/asiwasblock-a50c408169c32d200a4a2c7c8a6a1864.png";